import { render, staticRenderFns } from "./TodoForm.vue?vue&type=template&id=60da5400&scoped=true&"
import script from "./TodoForm.vue?vue&type=script&lang=js&"
export * from "./TodoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da5400",
  null
  
)

export default component.exports